<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box" >
                <div class="mb-5 w-100">
                    <button class="btn btn-primary float-right " @click="onAddUserClick" id="btnAddUser">Add User</button>
                </div>
                <div v-if="!loading">
                    <data-table :headings="userHeadings" :data="users" :hasActions="true" 
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onUserManagementActionClicked" 
                                @filterSearchClicked="onFilterSearchClicked"
                                @pagingUpdated="onPagingUpdate">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.searchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="pb-4">
                                    <label>Roles</label>
                                    <bootstrap-select  :selectOptions="rolesFilter" :selectedOption="filter.selectedRole" :elementId="'roleFilterSelect'"
                                                       :returnSelectedOptionText="true"
                                                       @changeSelect="onRoleFilterSelect"></bootstrap-select>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'userManagementFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    <!-- Add/Edit User Modal -->
    <modal-form :heading="userAddEditFormModal.heading" 
                :modalId="userAddEditFormModal.modalId" 
                :isSaving="userAddEditFormModal.isSaving" 
                :showModal="userAddEditFormModal.showModal"
                @closeClicked="onAddOrEditModalCloseClick"
                @saveButtonClicked="onAddOrEditUserFormModalSaveButtonClicked">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="nameInput">
                        First Name
                    </label>
                    <div class="text-danger" v-if="user.firstName.hasError">{{user.firstName.errorMessage}}</div>
                    <input type="text" class="form-control" id="nameInput" v-model="user.firstName.value">
                </div>
                <div class="form-group">
                    <label for="lastNameInput">
                        Last Name
                    </label>
                    <div class="text-danger" v-if="user.lastName.hasError">{{user.lastName.errorMessage}}</div>
                    <input type="text" class="form-control" id="lastNameInput" v-model="user.lastName.value">
                </div>
                <div class="form-group">
                    <label for="emailAddressInput">
                        Email Address
                    </label>
                    <div class="text-danger" v-if="user.emailAddress.hasError">{{user.emailAddress.errorMessage}}</div>
                    <input type="email" class="form-control" id="emailAddressInput" v-model="user.emailAddress.value">
                </div>

                <div class="form-group">
                    <label for="roleSelect">
                        Role
                    </label>
                    <div class="text-danger" v-if="user.roleId.hasError">{{user.roleId.errorMessage}}</div>
                    <bootstrap-select :selectOptions="roles" :selectedOption="user.roleId.value" :elementId="'roleSelect'"
                                        :returnSelectedOptionText="true"
                                        @changeSelect="onRoleSelect"></bootstrap-select>
                </div>

                <div class="form-group form-check" v-if="isUpdate">
                    <input class="form-check-input" type="checkbox" value="" id="resetPasswordCheckbox" v-model="resetPassword">
                    <label class="form-check-label" for="resetPasswordCheckbox">
                        Reset Password
                    </label>
                </div>
                <div class="text-danger" v-if="user.password.hasError">
                    {{user.password.errorMessage}}
                </div>
                <password-generator @passwordGenerated="onPasswordGenerated" v-if="!isUpdate || resetPassword"></password-generator>
            </form>
        </template>
    </modal-form>

<!--    <modal-form-->
<!--                :heading="markAsActiveOrInactive.heading" -->
<!--                :modalId="markAsActiveOrInactive.modalId" -->
<!--                :isSaving="markAsActiveOrInactive.isSaving" -->
<!--                :showModal="markAsActiveOrInactive.showModal"-->
<!--                @closeClicked="onMarkAsActiveOrInactiveModalCloseClick"-->
<!--                @saveButtonClicked="onMarkAsActiveOrInactiveModalSaveButtonClicked">-->
<!--        <template #form>-->
<!--            <active-inactive-radio-buttons :activeInactiveKey="markAsActiveOrInactive.isUserMarkedAsActiveKey"-->
<!--                                            :componentId="'markUserAsActiveOrInactiveRadioButtons'"-->
<!--                                            @activeInactiveSelected="onMarkUserActiveInactiveSelected"></active-inactive-radio-buttons>-->
<!--        </template>-->
<!--    </modal-form>-->

    <mark-as-active-inactive-modal
            :heading="markAsActiveOrInactive.heading"
            :modalId="markAsActiveOrInactive.modalId"
            :isSaving="markAsActiveOrInactive.isSaving"
            :showModal="markAsActiveOrInactive.showModal"
            :isActive="markAsActiveOrInactive.isActive"
            @closeClicked="markAsActiveOrInactive.showModal = false"
            @saveButtonClicked="onMarkAsActiveOrInactiveModalSaveButtonClicked"></mark-as-active-inactive-modal>

    <password-generator-modal :modalId="userPasswordReset.modalId"
                              :userId="userPasswordReset.userId"
                              :showModal="userPasswordReset.showModal"
                              :username="userPasswordReset.name"
                              @passwordGeneratorOkClicked="onPasswordGeneratorOkClicked"></password-generator-modal>
</div>
